/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
import type { TranslationKey } from '../models/TranslationKey';

export type DefaultTranslations = Record<keyof typeof TranslationKey, string>;

export const defaultTranslations: DefaultTranslations = {
  allBrands: 'All brands',
  articles: 'Articles',
  brands: 'Brands',
  callToActionCatalogueText: 'Call to action catalogue text',
  change: 'Change',
  failedToSubmit: 'Failed to submit',
  gotIt: 'Got it',
  loading: 'Loading',
  logIn: 'Log in',
  loggedInAs: 'Logged in as',
  menu: 'Menu',
  myAccount: 'My account',
  myFavoriteProducts: 'My favorite products',
  nextCatalogue: 'Next catalogue',
  noOptions: 'No options',
  open: 'Open',
  other: 'Other',
  popularProducts: 'Popular products',
  popularProductsInThisSearchQuery: 'Popular products in this search query',
  popularSearchQueries: 'Popular search queries',
  products: 'Products',
  register: 'Register',
  search: 'Search',
  searchDesktop: 'Search 60+ brands, 1000+ beauty and nutrition products',
  seeAll: 'See all',
  seeAllCatalogues: 'See all catalogues',
  seeAllResultsFor: 'See all results for',
  shopFor: 'Shop for',
  shoppingBag: 'Shopping bag',
  signIn: 'Sign in',
  topAreaBannerReferralMessage: 'Click to see more info!',
  view: 'View',
};

export const translationsNamespace = 'top-area';
